import __request__ from "routing/request";
export function checkCredentials(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations/symantecedr/checkCredentials", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations/symantecedr/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
